import { useRequestGetDashboardData } from '@/hooks/httpRequest';
import { ButtonFilterCountable } from '@/components/custom';
import { VerificationTypesEnum } from '@/lib/enum';
import { getSelectOptions } from '@/functions';
import { useEffect, useState } from 'react';
import { useListenEvents } from '@/hooks';

type TState = Record<VerificationTypesEnum, number>;

const CONSTS = {
  initState: {
    PROFILE_PHOTO: 0,
    IDENTITY: 0
  } as TState
}

const ControlsFiltersTypes = () => {

  const [state, setState] = useState<TState>(CONSTS.initState);
  const { data } = useRequestGetDashboardData();

  useListenEvents({
    type: 'photosVerified',
    callback: _ => setState(l => ({ ...l, PROFILE_PHOTO: (l.PROFILE_PHOTO - 1) }))
  });

  useListenEvents({
    type: 'profileCertified',
    callback: _ => setState(l => ({ ...l, IDENTITY: (l.IDENTITY - 1) }))
  });

  useEffect(
    () => {
      setState(
        l => ({
          ...l,
          PROFILE_PHOTO: data?.review?.photo ?? 0,
          IDENTITY: data?.review?.id ?? 0
        })
      );
    },
    [data?.review]
  );

  return (
    <div className='flex flex-wrap items-end gap-2'>
      {
        getSelectOptions('VerificationTypesEnum', { filter: l => l.value !== VerificationTypesEnum.BIO })
          .map(
            item => (
              <ButtonFilterCountable
                count={state[item.value as VerificationTypesEnum]}
                enableToggle={false}
                value={item.value}
                text={item.title}
                paramName='type'
                key={item.value} />
            )
          )
      }
    </div>
  );

};

export default ControlsFiltersTypes;
